import type { ISerialize } from '@/objects/ISerialize';

export class SignalrProductionKeepAliveSubscribeParameters implements ISerialize {
    public EventID: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { EventID?: number }) {
        this.EventID = values.EventID ?? 0;
    }

    public serialize(): string {
        return '{' + `"EventID": ${JSON.stringify(this.EventID)}` + '}';
    }

    /**
     * Creates an instance of SignalrProductionKeepAliveSubscribeParameters from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { EventID?: number }): SignalrProductionKeepAliveSubscribeParameters {
        return new SignalrProductionKeepAliveSubscribeParameters(values);
    }

    public static _FromServerJson(json: any): SignalrProductionKeepAliveSubscribeParameters {
        return new SignalrProductionKeepAliveSubscribeParameters({ EventID: json.EventID });
    }

    /**
     * Creates an instance of SignalrProductionKeepAliveSubscribeParameters from another instance of SignalrProductionKeepAliveSubscribeParameters.
     * @param other The SignalrProductionKeepAliveSubscribeParameters you want to clone
     * @returns A cloned SignalrProductionKeepAliveSubscribeParameters
     */
    public static FromOther(other: SignalrProductionKeepAliveSubscribeParameters): SignalrProductionKeepAliveSubscribeParameters {
        return SignalrProductionKeepAliveSubscribeParameters._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SignalrProductionKeepAliveSubscribeParameters.FromOther(this);
    }

    static NAME_OF_CLASS = 'SignalrProductionKeepAliveSubscribeParameters';
}
